import { render, staticRenderFns } from "./pageRender.vue?vue&type=template&id=34ed1573&scoped=true"
import script from "./pageRender.vue?vue&type=script&lang=js"
export * from "./pageRender.vue?vue&type=script&lang=js"
import style0 from "./pageRender.vue?vue&type=style&index=0&id=34ed1573&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ed1573",
  null
  
)

export default component.exports